/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner';

/**
 * 
 * @export
 * @interface FindAllScreenerTags200ResponseDataInner
 */
export interface FindAllScreenerTags200ResponseDataInner {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    facility_id?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    type?: number;
    /**
     * 
     */
    screener_lead_tags?: Array<FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner>;
}

/**
 * Check if a given object implements the FindAllScreenerTags200ResponseDataInner interface.
 */
export function instanceOfFindAllScreenerTags200ResponseDataInner(value: object): value is FindAllScreenerTags200ResponseDataInner {
    return true;
}

export function FindAllScreenerTags200ResponseDataInnerFromJSON(json: any): FindAllScreenerTags200ResponseDataInner {
    return FindAllScreenerTags200ResponseDataInnerFromJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerTags200ResponseDataInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'facility_id': json['facility_id'] == null ? undefined : json['facility_id'],
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : json['type'],
        'screener_lead_tags': json['screener_lead_tags'] == null ? undefined : ((json['screener_lead_tags'] as Array<any>).map(FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerFromJSON)),
    };
}

export function FindAllScreenerTags200ResponseDataInnerToJSON(json: any): FindAllScreenerTags200ResponseDataInner {
    return FindAllScreenerTags200ResponseDataInnerToJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseDataInnerToJSONTyped(value?: FindAllScreenerTags200ResponseDataInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_id': value['facility_id'],
        'name': value['name'],
        'type': value['type'],
        'screener_lead_tags': value['screener_lead_tags'] == null ? undefined : ((value['screener_lead_tags'] as Array<any>).map(FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerToJSON)),
    };
}

